export const apiUrl = 'https://web-cab.elit-taxi.ua/webcab2/'
export const mobileApiUrl = 'https://web-cab.elit-taxi.ua/mobile3/'
export const mapSource = 'https://dispatcher-ui.stage.cle.com.ua'